/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { extendObservable } from 'mobx';
import { createPaginatedResourceStoreHouse } from 'src/luis/core/stores/paginatedResourceStoreHouse';
import { UtteranceStore } from 'src/luis/projects/utterances/stores/utteranceStore';
import { UtteranceStoreHouse } from 'src/luis/types/stores/utterances/UtteranceStoreHouse';

/**
 * A factory function for creating an utterance store house,
 * which houses the pages containing labelStores.
 */
export const createUtteranceStoreHouse = ({ pageSize, totalSize }: { pageSize: number; totalSize: number }): UtteranceStoreHouse => {
    const resourceStoreHouse = createPaginatedResourceStoreHouse<UtteranceStore>({
        pageSize,
        totalSize,
        sortingProps: { property: 'createdDate', order: 'desc' }
    });

    return extendObservable(resourceStoreHouse, {}, {}, { deep: false });
};
